export default class BaseService {
   getErrors(error) {
      var errors = [];

      if (error && error.response) {
         console.log(error.response);
         if (error.response.status != 200) {
            var data = error.response.data;

            if (data.error != undefined && data.error.length > 0) {
               data.error.forEach(function (item) {
                  errors.push({
                     field: item.field,
                     message: item.message
                  });
               });
            } else if (data.success == 'false' || !data.success) {
               errors.push({
                  field: '',
                  message: data.message
               });
            }
         }
      }

      return errors;
   }
}



// WEBPACK FOOTER //
// ./src/services/base_service.js